import {getAxiosInstance, requestConfig} from "../../http-common";

const RESOURCE_NAME = "jwt";

const refreshToken = (groupCode?: string, entityId?: any) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/RefreshToken?groupCode=${groupCode ?? ""}${entityId ? "&entityId=" + entityId : ""}`, requestConfig());
};

const JwtService = {
  refreshToken,
};
export default JwtService;
